export default "__VITE_ASSET__Kwl2EZFx__"